import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { ASSIGNEDBRANCHES } from '../data/assigned-branches';
import { AppHelper } from "../appHelper/appHelper";
import { ServiceResult } from "../Infra/ServiceResult";
import { USERPROFILE } from "../data/user-profile";
import { MessageBox } from '../message-box/message-box';
import { SecurityService } from '../services/security.service';
import { BranchService } from '../services/branch.service';
import { RouteService } from '../services/route-service/route-service';
import { RefreshViewModel } from '../../Models/refreshViewModel';



@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private messageBox: MessageBox,
    private branchService: BranchService,
    private router: RouteService,
    private securityService: SecurityService) {
  }
  async canActivate() {
    if (this.securityService.IsAdmin) {
      await this.changeCurrentBranch(AppHelper.adminLayout);
      return await this.getAssignedBranches();
    } else {
      // not logged in so redirect to login page
      if (this.securityService.IsInBrowser)
        this.messageBox.showWarning('عدم دسترسی', 'برای دسترسی به این بخش نیاز به ورود دارید')
      this.router.gotoHome();
      return false;

    }
  }


  changeCurrentBranch(layoutName: string): Promise<ServiceResult> {
    return this.securityService.changeCurrentBranch(layoutName);
  }



  getAssignedBranches(userId?: string): Promise<boolean> {
    return this.branchService.getAssignedBranches(userId)
      .toPromise()
      .then(result => {
        ASSIGNEDBRANCHES.splice(0);
        if (result.successful == true) {
          if (result.returnValue.length > 0) {
            for (let item of result.returnValue) {
              ASSIGNEDBRANCHES.push(item);
              if (item.isDefaultBranch == true) {
                USERPROFILE.currentbranch = item;
              }
            }
            return true;
          }
        }
        // not logged in so redirect to login page

        if (this.securityService.IsInBrowser)
          this.messageBox.showWarning('عدم دسترسی', 'برای دسترسی به این بخش نیاز به ورود دارید')
        this.router.gotoHome();
        return false;

      })
      .catch(_ => false);
  }

}
